import { domain } from "../helpers/route_helper";

export const logErrors = error => {
  return window.$.ajax({
    method: "POST",
    url: `${domain}/api/log_errors`,
    data: { error }
  });
};
